<div [class.smart-assistant-module-collapse]="isCollapse" [style.max-height]="maxHeight">
    <span *ngIf="showImage" class="object-protection-title">{{i18n.createProtection}}</span>

    <!-- 轮播图 -->
    <app-smart-assistant-gif-container *ngIf="showImage" [subTitle]="subTitle"
        [gifTips]="str.protectionGifTips" imagePrefix="protection">
    </app-smart-assistant-gif-container>

    <ng-container *ngIf="hasWritePermission">

        <!-- 帮助提示（LUN和FS数量都为0，则不显示文字） -->
        <div class="object-protection-help-container" *ngIf="lunDatas.length !== 0 || fsDatas.length !== 0">
            <app-smart-assistant-switch [content]="i18n.helpTitle" [showIcon]="false"></app-smart-assistant-switch>
            <span class="sub">{{i18n.helpText}}</span>
        </div>

        <!-- LUN/文件系统对象 -->
        <div class="object-protection-container">
            <n-loading [visible]="loading"></n-loading>

            <!-- LUN -->
            <div class="object-protection-container-lun" *ngIf="lunDatas.length !== 0 && hasLunWrite">
                <span class="sub-text">{{i18n.lunLabel}}</span>

                <!-- 如果没有文件系统，则显示10条lun，否则显示5条 -->
                <app-smart-assistant-object-container icon="#app-icon-simple-lun"
                    *ngFor="let lun of (fsDatas.length === 0 ? lunDatas : lunDatas.slice(0, 5)); index as i"
                    [id]="'object-protection-lun-' + i"
                    [name]="lun.NAME"
                    [operateLabel]="i18n.createProtection"
                    (onClick)="createProtection(CreateSnapShotFromPageE.ProtectLun, lun)">
                </app-smart-assistant-object-container>
            </div>

            <!-- 文件系统 -->
            <div class="object-protection-container-fs" *ngIf="fsDatas.length !== 0 && hasFsWrite">
                <span class="sub-text">{{i18n.fsLabel}}</span>

                <!-- 如果没有LUN，则显示10条fs，否则显示5条 -->
                <app-smart-assistant-object-container icon="#app-icon-simple-file-system"
                    *ngFor="let fs of (lunDatas.length === 0 ? fsDatas : fsDatas.slice(0, 5)); index as i"
                    [id]="'object-protection-fs-' + i"
                    [name]="fs.NAME"
                    [operateLabel]="i18n.createProtection"
                    (onClick)="createProtection(CreateSnapShotFromPageE.Fs, fs)">
                </app-smart-assistant-object-container>
            </div>
        </div>
    </ng-container>
</div>
